/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/Settings';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const SettingsIcon = withMuiAdapter(Base, 'Settings');
